import { Component, OnInit } from '@angular/core';
import { NewsService } from '../services/news.service';
import { ActivatedRoute } from '@angular/router';
import { News } from '../models/news.model';
import { SpinnerService } from '../services/spinner.service';

@Component({
  selector: 'app-news-detail',
  templateUrl: './news-detail.component.html',
  styleUrls: ['./news-detail.component.scss']
})
export class NewsDetailComponent implements OnInit {

  public news = new News();
  public idNews: number;

  constructor(
    private newsService: NewsService,
    private route: ActivatedRoute,
    private spinnerService: SpinnerService
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.idNews = +params['idNovedad'];
      this.getById(this.idNews);
    });
  }

  getById(id: number) {
    this.spinnerService.updatedState(true);
    this.newsService.getById(id).subscribe(
      (data: News) => {
        console.log(data);
        this.spinnerService.updatedState(false);
        this.news = data;
      },
      (err) => {
        console.log(err);
        this.spinnerService.updatedState(false);
      }
    );
  }

}
